import { EntityManager, EntityQuery, Predicate } from 'breeze-client';
import { Invoice, Payment, PaymentCredit, PaymentLine } from '../model/entity-model';
import { Repository } from './repository';
export class InvoiceRepository extends Repository<Invoice> {
    constructor(manager: EntityManager) {
        super(manager, 'Invoice', 'invoices');
    }
    async getInvoices(expand?: string | string[], options?: any) {
        let predicate = new Predicate('deleted', '==', null)
        let query = EntityQuery.from('Invoices').where(predicate).orderByDesc('created').expand(expand);
        if (options) {
            if (options.take) query = query.take(options.take);
        }
        const data = await this.manager.executeQuery(query);
        return data.results;
    }

    async getOpenInvoices(expand?: string | string[]) {
        let predicate = new Predicate('deleted', '==', null).and('paid', '==', null).and('invoiceTypeId', '==', Invoice.Types.Invoice);
        const query = EntityQuery.from('Invoices').where(predicate).orderByDesc('created').expand(expand);
        const data = await this.manager.executeQuery(query);
        return data.results;
    }

    async getOpenPaymentCredits(customerId: number) {
        let predicate = new Predicate('deleted', '==', null).and('customerId', '==', customerId).and('applied', '==', null);
        const query = EntityQuery.from('PaymentCredits').where(predicate);
        const data = await this.manager.executeQuery(query);
        return data.results as PaymentCredit[];
    }

    async getOpenInvoicePaymentInfos(customerId: number) {
        const query = EntityQuery.from('OpenInvoicePaymentInfos').withParameters({ customerId });
        const data = await this.manager.executeQuery(query);
        return data.results;
    }
    async getInvoicePaymentInfos(paymentId: number) {
        const query = EntityQuery.from('InvoicePaymentInfos').withParameters({ paymentId });
        const data = await this.manager.executeQuery(query);
        return data.results;
    }

    async getPayments(expand?: string) {
        const predicate = new Predicate('deleted', '==', null);
        let query = EntityQuery.from('Payments').where(predicate);
        if (!!expand) query = query.expand(expand);
        const data = await this.manager.executeQuery(query);
        return data.results as Payment[];
    }

    async getPaymentLines(invoiceId: any) {
        let predicate = new Predicate('deleted', '==', null).and('payment.deleted', '==', null).and('invoiceId', '==', invoiceId);
        let query = EntityQuery.from('PaymentLines').where(predicate);
        const data = await this.manager.executeQuery(query);
        return data.results as PaymentLine[];
    }

    async getCredits(options?) {
        let query = EntityQuery.from('PaymentCredits').where('deleted', '==', null);
        if (options) {
            if (options.customerId) query = query.where('customerId', '==', options.customerId);
            if (options.unapplied) query = query.where('paymentId', '==', null);
            if (options.expand) query = query.expand(options.expand);
        }
        const data = await this.manager.executeQuery(query);
        return data.results as PaymentCredit[];
    }
}
